import { Pipe, PipeTransform } from '@angular/core';
import { appConfig } from '~/app.config';

@Pipe({
  name: 'priceConversion',
  pure: true,
})
export class PriceConversionPipe implements PipeTransform {
  transform(value: number): number {
    return Math.round((value / appConfig.levValue) * 100) / 100;
  }
}
